import { render, staticRenderFns } from "./cardPais.vue?vue&type=template&id=0b54f8ad&scoped=true&"
import script from "./cardPais.vue?vue&type=script&lang=js&"
export * from "./cardPais.vue?vue&type=script&lang=js&"
import style0 from "./cardPais.vue?vue&type=style&index=0&id=0b54f8ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54f8ad",
  null
  
)

export default component.exports